var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "certificate_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#certificate_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.028 18.85l-2.625-.55a.859.859 0 01-.525-.362.823.823 0 01-.15-.613l.25-2.7L2.203 12.6a.818.818 0 01-.25-.6c0-.233.083-.433.25-.6l1.775-2.025-.25-2.7a.823.823 0 01.15-.613.859.859 0 01.525-.362l2.625-.55 1.375-2.325a.96.96 0 01.512-.4.863.863 0 01.613.025l2.475 1.05 2.475-1.05a.863.863 0 01.613-.025.96.96 0 01.512.4l1.375 2.325 2.625.55c.217.05.392.171.525.362a.822.822 0 01.15.613l-.25 2.7 1.775 2.025c.167.167.25.367.25.6a.818.818 0 01-.25.6l-1.775 2.025.25 2.7a.822.822 0 01-.15.613.859.859 0 01-.525.362l-2.625.55-1.375 2.325a.96.96 0 01-.512.4.863.863 0 01-.613-.025l-2.475-1.05-2.475 1.05a.863.863 0 01-.613.025.96.96 0 01-.512-.4L7.028 18.85zm3.3-4.275c.167.167.375.25.625.25s.459-.083.625-.25l4.15-4.15c.15-.15.225-.329.225-.538a.733.733 0 00-.225-.537.72.72 0 00-.525-.225c-.2 0-.383.075-.55.225l-3.7 3.725-1.625-1.625a.737.737 0 00-.538-.188.74.74 0 00-.512.213.72.72 0 00-.225.525c0 .2.075.375.225.525l2.05 2.05zm-.875 5.375l2.55-1.075 2.575 1.075 1.425-2.4 2.75-.625-.25-2.825 1.85-2.1-1.85-2.125.25-2.825-2.75-.6-1.45-2.4-2.55 1.075L9.428 4.05l-1.425 2.4-2.75.6.25 2.825L3.653 12l1.85 2.1-.25 2.85 2.75.6 1.45 2.4z",
    fill: "#12385C"
  }))));
}
export default SvgCertificate;